export function isValidJson(jsonString) {
    try {
        JSON.parse(jsonString);
    }
    catch (e) {
        return false;
    }
    return true;
}
export function formatSize(size) {
    if (!size && size !== 0)
        return "n/a";
    if (size > 1024) {
        const sizeKb = Math.ceil(size / 1024);
        if (sizeKb > 1024) {
            const sizeMb = sizeKb / 1024;
            if (sizeMb > 1024) {
                return (sizeMb / 1024).toFixed(2) + "GB";
            }
            else {
                return sizeMb.toFixed(2) + "MB";
            }
        }
        else {
            return sizeKb + "KB";
        }
    }
    else {
        return size + "Bytes";
    }
}
//# sourceMappingURL=utils.js.map